module.exports = __webpack_public_path__ + "static/img/3_1_6_2.f7d2d64c.jpg";